// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatausdt0 } from "../../../icons/mono/build/icon-statausdt0.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatausdtZeroIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatausdt0.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatausdtZeroIcon.displayName = 'StatausdtZeroIcon';
}

export default StatausdtZeroIcon;